import { createQueryKeys } from '@lukemorales/query-key-factory';

/**
 * Query keys for auth API calls
 */
export const auth = createQueryKeys('auth', {
	all: null,
	me: null,
	debug: null,
});
